<template>
  <v-container v-if="
    RBAC_configuration_VIEW_CONFIGURATION &&
    RBAC_configuration_EDIT_CONFIGURATION
  ">
    <base-material-card :renderCard="card" color="secondary" icon="mdi-help-circle" :title="$t('help_guide')">
      <v-toolbar flat>
        <template v-slot:extension>
          <v-tabs v-model="tabs" grow background-color="primary" centered icons-and-text>
            <v-tab href="#mobile-tabs-1">
              {{ $t("general_guide") }}
              <v-icon>mdi-book-open-page-variant</v-icon>
            </v-tab>

            <v-tab href="#mobile-tabs-2">
              {{ $t("application_guide") }}
              <v-icon>mdi-apps</v-icon>
            </v-tab>
          </v-tabs>
        </template>
      </v-toolbar>

      <v-tabs-items v-model="tabs">
        <v-tab-item value="mobile-tabs-1">
          <v-card flat>
            <v-card-text>
              <v-simple-table>
                <tbody>
                  <tr v-for="rotta in generalHelp" :key="rotta.name">
                    <td>
                      <v-file-input v-model="rotta.files" @change="uploadDoc('title', rotta)" color="primary"
                        :placeholder="$t('upload_document')" prepend-icon="mdi-cloud-upload-outline" outlined
                        accept="image/*, .pdf" :display-size="1000" />
                    </td>
                    <td>
                      <v-btn v-if="rotta.haveHelp" class="mx-2" fab dark small color="primary"
                        @click="showHelp('title', rotta.name)">
                        <v-icon dark> mdi-card-search-outline </v-icon>
                      </v-btn>

                      <v-btn v-if="rotta.haveHelp && rotta.internalHelp" class="mx-2" fab dark small color="error"
                        @click="deleteDoc('title', rotta)">
                        <v-icon dark> mdi-delete </v-icon>
                      </v-btn>
                    </td>
                    <td v-if="rotta.haveHelp">{{ rotta.name }}</td>
                    <td v-else>
                      <v-text-field :rules="required" v-model="rotta.newName" :label="$t('title')"></v-text-field>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
              <v-row v-if="!emptyLine">
                <v-col cols="12" class="text-center">
                  <v-btn class="mx-5" @click="addNewGeneral()" color="success">{{ $t("add_guide") }}</v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item value="mobile-tabs-2">
          <v-card flat>
            <v-card-text>
              <v-simple-table>
                <tbody>
                  <tr v-for="rotta in routeHelp" :key="rotta.path">
                    <td>
                      <v-file-input v-model="rotta.files" @change="uploadDoc('route', rotta)" color="primary"
                        :placeholder="$t('upload_document')" prepend-icon="mdi-cloud-upload-outline" outlined
                        accept="image/*, .pdf" :display-size="1000" />
                    </td>
                    <td>
                      <v-btn v-if="rotta.haveHelp" class="mx-2" fab dark small color="primary"
                        @click="showHelp('route', rotta.path)">
                        <v-icon dark> mdi-card-search-outline </v-icon>
                      </v-btn>

                      <v-btn v-if="rotta.haveHelp && rotta.internalHelp" class="mx-2" fab dark small color="error"
                        @click="deleteDoc('route', rotta)">
                        <v-icon dark> mdi-delete </v-icon>
                      </v-btn>
                    </td>
                    <td>{{ rotta.name }}</td>
                    <td>{{ rotta.path }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </base-material-card>
  </v-container>
</template>

<script>
import Swal from "sweetalert2";

export default {
  name: "edit-help",
  components: {},
  props: {
    card: false,
    role: null,
  },
  data() {
    return {
      RBAC_configuration_EDIT_CONFIGURATION: false,
      RBAC_configuration_VIEW_CONFIGURATION: false,
      tabs: null,
      required: [(value) => !!value || this.$t("required_field")],
      generalHelp: [],
      routeHelp: [],
    };
  },
  computed: {
    emptyLine() {
      let filtered = this.generalHelp.filter((help) => {
        return !help.haveHelp;
      });
      if (filtered.length > 0) return true;
      else return false;
    },
  },
  watch: {},
  mounted() {
    this.reloadConfig();
    this.RBAC_configuration_VIEW_CONFIGURATION = this.checkUserRole(
      "configuration",
      "VIEW_CONFIGURATION"
    );
    this.RBAC_configuration_EDIT_CONFIGURATION = this.checkUserRole(
      "configuration",
      "EDIT_CONFIGURATION"
    );
  },
  methods: {
    uploadDoc(mode, obj) {
      let _ = this;
      if (obj.newName) obj.name = obj.newName;
      if (obj.name === "") {
        Swal.fire({
          type: "error",
          html: this.$t("required_title"),
        });
        return;
      }

      let saveObj = {
        title: mode === "title" ? obj.name : "",
        route: mode === "route" ? obj.path : "",
        lang: window.selectedLanguage,
      };

      let file = obj.files;
      if (!file) return;
      let reader = new FileReader();
      reader.onload = (e) => {
        saveObj.base64 = e.target.result;
        // Carica immagine
        _.chiamataAxios("PUT", "/auth/portal/saveHelp/", {
          body: saveObj,
        }).then(
          (response) => {
            if (response.msg.esito) {
              _.reloadConfig();
            }
          },
          "always",
          500
        );
      };
      reader.readAsDataURL(file);
    },
    deleteDoc(mode, obj) {
      let _ = this;
      let deleteObj = {
        title: mode === "title" ? obj.name : "",
        route: mode === "route" ? obj.path : "",
        lang: window.selectedLanguage,
      };
      _.chiamataAxios("DELETE", "/auth/portal/deleteHelp/", {
        body: deleteObj,
      }).then((response) => {
        if (response.msg.esito) {
          let html = "<strong>" + response.msg.msgTxt + "</strong>"
          Swal.fire({
            type: "success",
            html: html,
          });
          _.reloadConfig();
        }
      });
    },
    addNewGeneral() {
      this.generalHelp.push({
        path: "",
        name: "",
        newName: "",
        haveHelp: false,
        files: [],
      });
    },
    haveHelp(path) {
      if (
        window &&
        window.selectedLanguage &&
        window.systemData &&
        window.systemData.help &&
        window.systemData.help[window.selectedLanguage] &&
        window.systemData.help[window.selectedLanguage][path] &&
        window.systemData.help[window.selectedLanguage][path].length === 1
      )
        return true;
      else return false;
    },
    haveInternalHelp(path) {
      if (
        window &&
        window.selectedLanguage &&
        window.systemData &&
        window.systemData.help &&
        window.systemData.help[window.selectedLanguage] &&
        window.systemData.help[window.selectedLanguage][path] &&
        window.systemData.help[window.selectedLanguage][path].length === 1
      )
        return window.systemData.help[window.selectedLanguage][path][0]
          .internal;
      else return false;
    },
    showHelp(mode, key) {
      if (mode === "route")
        this.$documentViewer.documentViewerRsp.docUrl =
          "/public/portal/getRouteHelp?path=" + key;
      if (mode === "title")
        this.$documentViewer.documentViewerRsp.docUrl =
          "/public/portal/getTitleHelp?title=" + key;
    },
    reloadConfig() {
      let _ = this;
      _.generalHelp = [];
      _.routeHelp = [];
      this.chiamataAxios("GET", "/public/portal/getSystemData").then(
        (response) => {
          if (response.msg.esito) {
            window.systemData = response.data;
            if (
              window &&
              window.selectedLanguage &&
              window.systemData &&
              window.systemData.help &&
              window.systemData.help[window.selectedLanguage] &&
              window.systemData.help[window.selectedLanguage]["general"]
            ) {
              _.generalHelp =
                window.systemData.help[window.selectedLanguage] &&
                window.systemData.help[window.selectedLanguage]["general"].map(
                  (rotta) => {
                    return {
                      path: "",
                      name: rotta.title,
                      newName: null,
                      haveHelp: true,
                      internalHelp: rotta.internal,
                      files: [],
                    };
                  }
                );
            } else _.generalHelp = [];

            // Rotte
            let rotte = _.$router.options.routes.filter((rotta) => {
              return rotta.path === "/portal";
            });
            _.routeHelp = rotte[0].children
              .map((rotta) => {
                let newRotta = {
                  path: "/portal/" + rotta.path.split(":")[0],
                  name: rotta.name,
                  haveHelp: false,
                  internalHelp: false,
                  files: [],
                };

                if (newRotta.path.substr(-1) === "/")
                  newRotta.path = newRotta.path.substr(
                    0,
                    newRotta.path.length - 1
                  );
                newRotta.haveHelp = _.haveHelp(newRotta.path);
                newRotta.internalHelp = _.haveInternalHelp(newRotta.path);
                return newRotta;
              })
              .filter((rotta) => {
                return rotta.path !== "";
              });
          }
        }
      );
    },
  },
};
</script>